var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-header"},[_c('tag',{staticClass:"bg-primary text-white",attrs:{"text":_vm.category}}),_vm._v(" "),_c('p',[_vm._v("\n        por "),_c('span',[_vm._v("UGT-SP")]),_vm._v(", "+_vm._s(_vm.date)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }